/* eslint-disable @typescript-eslint/no-explicit-any */
import { forwardRef, ForwardedRef } from 'react';

import { ContainerOptions, RowColumnProps } from './config';
import { Row } from './Row';
import { Column } from './Column';

export type RowOrColumnProps<As extends ContainerOptions = 'div'> = RowColumnProps<As> & {
  orientation: 'vertical' | 'horizontal';
};

const RowOrColumnBase = <As extends ContainerOptions = 'div'>(
  { orientation, ...props }: RowOrColumnProps<As>,
  ref: ForwardedRef<HTMLElement>,
): JSX.Element => {
  return orientation === 'horizontal' ? (
    <Row ref={ref} {...(props as any)} />
  ) : (
    <Column ref={ref} {...(props as any)} />
  );
};

export const RowColumn = forwardRef(RowOrColumnBase);
